
/**
 * This files contains non-react functions which support searchpage.js
 *
 * See also: searchpage_utils.test.js
 */


/**
 * Parse restrictions, obtained (and parsed from query strings)
 *
 * @return object (parsed query string, with values of "true"/"false" have been replaced
 * with true/false (all others left alone)
 */
export function parseFacetRestricts(restrictQueryString) {
    const rawQs = Object.fromEntries(
        new URLSearchParams(restrictQueryString)
    );
    const origFacetRestricts = {};

    Object.keys(rawQs).forEach(key => {
        if (rawQs[key] === "true") {
            origFacetRestricts[key] = true;
        } else if (rawQs[key] === "false") {
            origFacetRestricts[key] = false;
        } else {
            origFacetRestricts[key] = rawQs[key];
        }
    });

    return origFacetRestricts;
}
